module.exports = __webpack_public_path__ + "img/tips1_botlist4img6.c0bdb5f3.jpg";